import { FormattedMessage, useIntl } from "react-intl";
import React, { useEffect, useRef, useState } from "react";
import NewsEventCard, {
  getInfoPills,
} from "../../../elements/cards/newsEventCard.jsx";
import HorizontalScroller from "../../../elements/cards/horizontalscroller.containter.jsx";
import EinrichtungLinkCard from "../../../elements/cards/einrichtung.card.jsx";
import InteractionButtons from "./interactionButtons.infoCard.jsx";
import {
  EVENTS_UNSORTED,
  NEWS,
  PHONEBOOK_ENTRIES,
} from "../../../../reduxStore/actions/main";
import { poitypes } from "../../../../functions/classes/poi.class.js";
import PhonebookCard from "../../../elements/cards/Phonebook.card.component";
import { getEvent } from "../../../events/EventList.component";
import { isMobile } from "react-device-detect";
import StandardCard from "../../../elements/cards/StandardCard.card.jsx";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import StandardText from "../../../elements/text/standardText.text.jsx";
import { AppOverlayIFrame } from "../../../../functions/classes/miscelleanous.classes.js";
import StandardSubline from "../../../elements/text/standardSubline.text.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StandardInformation from "../../../elements/text/standardInformation.text.jsx";
import { GeneratedQRCode } from "../../../elements/cards/GeneratedQRCode";

export default function POICardContent({
  setSharedItem,
  poi,
  setPage,
  setStatus,
  currentChildren,
  setCurrentFeature,
  setFloorNumber,
  setCurrentAppOverlay,
  isApp,
  isTerminal,
}) {
  const showEvent = (item) => {
    setCurrentAppOverlay(
      new AppOverlayIFrame(item.name, item.website, { contentType: "event" })
    );
    setSharedItem({
      ...item,
      event: getEvent(item) ? getEvent(item) : null,
    });
  };
  const showNews = (item) => {
    setCurrentAppOverlay(
      new AppOverlayIFrame(item.name, item.website, { contentType: "news" })
    );
    setSharedItem(item);
  };

  return (
    <div>
      <InfoHead
        // headline={poi.short != null ? poi.short : poi.name}
        headline={poi.name}
        subline={poi.address}
        currentFeature={poi}
        setPage={setPage}
        setStatus={setStatus}
        isApp={isApp}
        setCurrentFeature={setCurrentFeature}
        isTerminal={isTerminal}
      />
      <Photos titleImageUrl={poi.titleImageUrl} />
      <EinrichtungsLinkCards
        currentChildren={currentChildren}
        currentFeature={poi}
        setCurrentFeature={setCurrentFeature}
        setFloorNumber={setFloorNumber}
      />
      <NewsCards showNews={showNews} currentFeature={poi} />
      <EventCards
        showEvent={showEvent}
        currentFeature={poi}
        setCurrentFeature={setCurrentFeature}
        setStatus={setStatus}
      />
      <PhoneCards currentFeature={poi} />
    </div>
  );
}

/**
 *
 * @param headline
 * @param subline
 * @param setPage
 * @param setStatus
 * @param {POI} currentFeature
 * @param isApp
 * @return {JSX.Element}
 * @constructor
 */
export function InfoHead({
  headline,
  subline,
  setPage,
  setStatus,
  currentFeature,
  isApp,
  setCurrentFeature,
  isTerminal,
}) {
  const intl = useIntl();
  const localSting =
    intl.locale === "de"
      ? "de_DE"
      : intl.locale === "en"
      ? "en_EN"
      : intl.locale;
  return (
    <div
      className={
        isMobile ? "text-left pl-3 pr-3 pb-3" : "text-left pl-4 pr-4 pb-3 pt-4"
      }
    >
      <StandardHeadline
        ariaLabel={intl.formatMessage(
          { id: "einrichtungscard.screenreader.headline" },
          { name: headline }
        )}
        text={headline} // Das hier ist vermutlich die Abkürzung des POI.
        className={"text-left"}
        type={"h1"}
      />
      <StandardSubline
        ariaLabel={intl.formatMessage(
          { id: "einrichtungscard.screenreader.address" },
          { address: subline }
        )}
      >
        {subline}
      </StandardSubline>
      {currentFeature?.additionalData?.zusatzinfoLabel &&
      currentFeature.additionalData.zusatzinfoLabel[localSting] ? (
        <div className="mb-2 white-space-break">
          {currentFeature.additionalData.zusatzinfoLabel[localSting]}
        </div>
      ) : null}
      {!currentFeature.hasLocation() && (
        <StandardInformation>
          <FontAwesomeIcon
            icon={["fal", "map-marker-alt-slash"]}
            className={"mr-2"}
          />
          <span>{intl.formatMessage({ id: "infoCard.noLocation" })}</span>
        </StandardInformation>
      )}
      {currentFeature.getParent() && (
        <StandardInformation
          onClick={() => setCurrentFeature(currentFeature.getParent())}
          className={"mb-3 standardInformation--belongsTo"}
        >
          <FontAwesomeIcon className={"mr-2"} icon={["fal", "house"]} />
          <span>
            <FormattedMessage id={"infoCard.belongsTo"} />{" "}
            <b>{currentFeature.getParent().name}</b>
          </span>
        </StandardInformation>
      )}
      <InteractionButtons
        setStatus={setStatus}
        currentFeature={currentFeature}
        setPage={setPage}
        isApp={isApp}
      />
      <ImportantNotice poi={currentFeature} />
      <GeneratedQRCode
        inCard={false}
        className={"mt-3"}
        isTerminal={isTerminal}
      />
    </div>
  );
}
function ImportantNotice({ poi }) {
  const intl = useIntl();
  if (!poi.warning) return null;

  return (
    <StandardCard
      className={"standardCard--warning standardCard--warning__poiCard mb-3"}
    >
      <StandardHeadline
        className={
          "standardHeadline--warning standardHeadline--warning__poiCard"
        }
      >
        {intl.formatMessage({ id: "einrichtungscard.attention" })}
      </StandardHeadline>
      <StandardText
        className={"standardText--warning standardText--warning__poiCard"}
      >
        {poi.warning}
      </StandardText>
    </StandardCard>
  );
}
function Photos({ titleImageUrl }) {
  const [picCanShow, setPicCanShow] = useState(false);
  const [blurred, setBlurred] = useState(true);
  const timer = useRef(null);

  useEffect(() => {
    setBlurred(true);
    setPicCanShow(false);
    clearTimeout(timer.current);
    setTimeout(() => {
      setPicCanShow(true);
    }, 250);
  }, [titleImageUrl]);

  if (titleImageUrl != null && picCanShow) {
    return (
      <HorizontalScroller id={"hs-photos-container"} className={isMobile ? "p-3 mb-3" : "p-4 mb-3"}>
        <div
          style={{
            filter: blurred ? "blur(5px)" : "none",
            maxHeight: "100%",
            maxWidth: "100%",
          }}
          className={"rounded-1 shadow-1 mb-3 mr-3 col-12 p-0 overflow-hidden"}
        >
          <img
            loading={"lazy"}
            src={titleImageUrl}
            className={"w-100"}
            onLoad={() => setBlurred(false)}
          />
        </div>
      </HorizontalScroller>
    );
  } else return null;
}

/**
 * Die Teile, die die "Zugehörige Orte" anzeigen
 * @param setFloorNumber
 * @param setCurrentFeature
 * @param currentFeature
 * @param currentChildren
 * @return {JSX.Element|null}
 * @constructor
 */
function EinrichtungsLinkCards({
  setFloorNumber,
  setCurrentFeature,
  currentFeature,
  currentChildren,
}) {
  const [parentPOI, setParentPOI] = useState(null);
  /** @type [POI[], Function] */
  const [childrenPOIs, setChildrenPOIs] = useState([]);
  const [linkedEntries, setLinkedEntries] = useState([]);

  const handleClick = (feature) => {
    setCurrentFeature(feature);
  };

  useEffect(() => {
    const linkedLocations = [];

    if (
      parentPOI &&
      parentPOI.type !== poitypes.building &&
      parentPOI.type !== poitypes.campus &&
      parentPOI.type !== poitypes.floor
    ) {
      // zeigt an, ob diese POI Card gerade auf der Karte mit einem roten marker zu sehen ist
      // dies könnte nicht der fall sein, wenn eines der children ausgewählt wird und ihre children als
      //EinrichtungsCards anzeigt!
      const isOnMap = currentChildren
        ? currentChildren.find((c) => c.id !== parentPOI.id)
        : false;

      linkedLocations.push({
        shownOnMap: isOnMap,
        hasLocation: parentPOI.hasLocation(),
        onClick: () => handleClick(parentPOI),
        key: parentPOI.name,
        name: parentPOI.name,
        address: parentPOI.address,
      });
    }

    const filteredChildrenPois = childrenPOIs.filter((childPoi, index) => {
      return (
        (childPoi.type !== poitypes.campus &&
          childPoi.type !== poitypes.floor &&
          childPoi.type !== poitypes.building &&
          childPoi.type !== poitypes.parking) ||
        // buildings und parkings auch anzeigen aber NUR wenn priority ist!
        (childPoi.type === poitypes.building && childPoi.priority != null) ||
        (childPoi.type === poitypes.parking && childPoi.priority != null)
      );
    });
    filteredChildrenPois.sort((a, b) => {
      // sort children by priority!
      const first = a.priority != null ? a.priority : 0;
      const second = b.priority != null ? b.priority : 0;

      return second - first;
    });
    filteredChildrenPois.forEach((childPoi) => {
      const isOnMap = currentChildren
        ? currentChildren.find((c) => c.id === childPoi.id)
        : false;

      linkedLocations.push({
        shownOnMap: isOnMap,
        hasLocation: childPoi.hasLocation(),
        onClick: () => handleClick(childPoi),
        key: childPoi.id + childPoi.name,
        name: childPoi.name,
        address: childPoi.address,
      });
    });

    setLinkedEntries(linkedLocations);
  }, [currentFeature, parentPOI, childrenPOIs]);

  useEffect(() => {
    setChildrenPOIs(currentFeature.getChildren());
    setParentPOI(currentFeature.getParent());
  }, [currentFeature]);

  if (linkedEntries.length) {
    return (
      <>
        <StandardHeadline
          type={"h4"}
          className={isMobile ? "pr-3 pl-3" : "pl-4 pr-4"}
        >
          <FormattedMessage id="einrichtungscard.locations" />
        </StandardHeadline>
        <HorizontalScroller
          id={"hs-locations-container"}
          className={`${isMobile ? "p-3" : "p-4"} mb-3 position-relative`}
        >
          {linkedEntries.map((location, index) => (
            <EinrichtungLinkCard
              shownOnMap={location.shownOnMap}
              hasLocation={location.hasLocation}
              onClick={location.onClick}
              key={location.key + index}
              name={location.name}
              address={location.address}
            />
          ))}
        </HorizontalScroller>
      </>
    );
  }
  return null;
}

function NewsCards(props) {
  const [linkedEntries, setLinkedEntries] = useState([]);

  useEffect(() => {
    if (!props.currentFeature || !props.currentFeature.relations) {
      setLinkedEntries([]);
      return;
    }

    let linkedEntries = props.currentFeature.relations
      .filter((id) => NEWS.find((pe) => pe.id === id))
      .map((id) => NEWS.find((pe) => pe.id === id))
      .sort((a, b) => {
        if (!a.datetime || !b.datetime) return false;
        const dateA = new Date(a.datetime).getTime();
        const dateB = new Date(b.datetime).getTime();

        if (dateA && dateB) {
          return dateB - dateA;
        } else {
          console.warn("Neuigkeiten hatten keine Dates");
          return false;
        }
      });
    linkedEntries = [...new Set(linkedEntries)];
    setLinkedEntries(linkedEntries);
  }, [props.currentFeature]);

  if (!linkedEntries.length) return null;
  return (
    <>
      <StandardHeadline
        type={"h4"}
        className={isMobile ? "ml-3 mr-3" : "ml-4 mr-4"}
        text={<FormattedMessage id="einrichtungscard.news" />}
      />
      <HorizontalScroller id={"hs-news-container"} className={isMobile ? "p-3 mb-3" : "p-4 mb-3"}>
        {linkedEntries.map((entry) => (
          <NewsEventCard
            key={entry.id}
            headline={entry.name}
            datetime={entry.datetime}
            backgroundUrl={entry.titleImageUrl}
            onClick={() => props.showNews(entry)}
            contentText={entry.description}
            standardCardClassName={"col-10 mr-3 standardCard__news"}
          />
        ))}
      </HorizontalScroller>
    </>
  );
}
function EventCards(props) {
  const [linkedEntries, setLinkedEntries] = useState([]);

  useEffect(() => {
    if (!props.currentFeature || !props.currentFeature.relations) {
      setLinkedEntries([]);
      return;
    }

    // hier wird doch nach globalpois gesucht???
    const linkedEntries = props.currentFeature.relations
      .filter((id) => EVENTS_UNSORTED.find((pe) => pe.id === id))
      .map((id) => EVENTS_UNSORTED.find((pe) => pe.id === id));
    setLinkedEntries(linkedEntries);
  }, [props.currentFeature]);

  if (!linkedEntries.length) return null;

  return (
    <>
      <StandardHeadline
        type={"h4"}
        className={isMobile ? "mr-3 ml-3" : "mr-4 ml-4"}
        text={<FormattedMessage id="einrichtungscard.events" />}
      />
      <HorizontalScroller id={"hs-events-container"} className={isMobile ? "p-3 mb-3" : "p-4 mb-3"}>
        {linkedEntries.map((entry) => {
          const infoPills = getInfoPills(
            entry,
            props.setCurrentFeature,
            props.history,
            () => props.setStatus("SET_PRE_OPEN")
          );
          return (
            <NewsEventCard
              infoPills={infoPills}
              key={entry.id}
              headline={entry.name}
              datetime={entry.datetime}
              onClick={() => props.showEvent(entry)}
              standardCardClassName={"col-10 mr-3 standardCard__events"}
              contentText={entry.description}
            />
          );
        })}
      </HorizontalScroller>
    </>
  );
}
function PhoneCards({ currentFeature }) {
  const [linkedEntries, setLinkedEntries] = useState([]);

  useEffect(() => {
    if (!currentFeature || !currentFeature.relations) {
      setLinkedEntries([]);
      return;
    }

    const linkedEntries = currentFeature.relations
      .filter((id) => PHONEBOOK_ENTRIES.find((pe) => pe.id === id))
      .map((id) => PHONEBOOK_ENTRIES.find((pe) => pe.id === id));
    setLinkedEntries(linkedEntries);
  }, [currentFeature]);

  if (!linkedEntries.length) return null;

  return (
    <>
      <h4 className={isMobile ? "pl-3 pr-3" : "pl-4 pr-4"}>
        <FormattedMessage id="einrichtungscard.phonebook" />
      </h4>
      <HorizontalScroller id={"hs-phonebook-container"} className={isMobile ? "p-3 mb-3" : "p-4 mb-3"}>
        {linkedEntries.map((entry) => (
          <PhonebookCard
            key={entry.id}
            name={entry.name}
            phone={entry.phone}
            description={entry.description}
          />
        ))}
      </HorizontalScroller>
    </>
  );
}
